<template>
  <div class="modal-header">
    <button class="close" data-dismiss="modal" aria-label="Close">
      <span>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-close"></use>
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'modal-header'
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  .modal-header {
    min-height: .2rem;
    .close {
      opacity: 1;
      border: 0;
      color: #999;
      font-size: .14rem;
      float: right;
      background: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// ModalHeader.vue?d0431f5c